import { render, staticRenderFns } from "./ScrollCard.vue?vue&type=template&id=09fa0540&scoped=true"
import script from "./ScrollCard.vue?vue&type=script&lang=js"
export * from "./ScrollCard.vue?vue&type=script&lang=js"
import style0 from "./ScrollCard.vue?vue&type=style&index=0&id=09fa0540&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fa0540",
  null
  
)

export default component.exports